<template>
  <div class="page-wrap" :class="{ 'is-modal': modal }">
    <div class="page" ref="container">
      <!--ヘッダーここから-->
      <QuestionHeader
        v-if="!modal"
        :list="list"
        :limitTime="limitTime"
        :config="config"
        @open="
          (e) => {
            $refs[e].show();
          }
        "
        @hide="
          (e) => {
            $refs[e].hide();
          }
        "
        @setConfig="setConfig"
      />
      <!--ヘッダここまでー-->
      <div
        id="question-wrap"
        ref="qwrap"
        :style="{ marginBottom: spacerNeeded && qComment ? 0 : 'auto' }"
      >
        <div class="container" id="question">
          <!-- 問題画像エリア ここから-->
          <div class="question-container">
            <div class="presentation-block">
              <div
                v-if="!modal"
                class="swiper-button-prev"
                @click.prevent="prev"
                @touchend.prevent="prev"
                :class="{ disabled: prevDisabled }"
              ></div>

              <Presentations
                :question="question"
                :setting="setting"
                :now="now"
                @next="next"
                @prev="prev"
                @pauseTimer="pauseTimer"
                @resumeTimer="resumeTimer"
              />

              <div
                v-if="!modal"
                class="swiper-button-next"
                @click.prevent="next"
                @touchend.prevent="next"
              ></div>
            </div>
          </div>

          <div class="input-container">
            <Forms :question="question" :key="`form-${now}`" @setSend="send"/>
            <!-- 解答ボタン -->
            <div
              v-if="!sent && question.question.type !== 'self'"
              class="btn-answer"
              @click="send"
            >
              解答
            </div>
          </div>
        </div>
      </div>
      <div class="spacer" v-if="spacerNeeded && qComment"></div>
    </div>

    <!-- モーダル ここから -->
    <b-modal
      id="modal-top"
      ref="modal-top"
      centered
      @show="pauseTimer"
      @hidden="resumeTimer"
    >
      <template v-slot:modal-header>
        <button
          type="button"
          class="close"
          @click.prevent="$refs['modal-top'].hide()"
          @touchend.prevent="$refs['modal-top'].hide()"
          aria-label="Close"
        >
          <span aria-hidden="true" class="btn-close">&times;</span>
        </button>
      </template>
      <b-container fluid>TOP画面に戻りますか？</b-container>
      <template v-slot:modal-footer>
        <button
          type="button"
          class="btn btn-secondary btn-modal"
          @click.prevent="$refs['modal-top'].hide()"
          @touchend.prevent="$refs['modal-top'].hide()"
        >
          いいえ
        </button>
        <button
          type="button"
          @click.prevent="goIndex"
          @touchend.prevent="goIndex"
          class="btn btn-modal-yes btn-modal"
        >
          はい
        </button>
      </template>
    </b-modal>
    <!-- モーダル ここまで -->
    <b-modal
      id="modal-check"
      ref="modal-check"
      centered
      @show="pauseTimer"
      @hidden="resumeTimer"
    >
      <template v-slot:modal-header>
        <button
          type="button"
          class="close"
          @click.prevent="$refs['modal-check'].hide()"
          @touchend.prevent="$refs['modal-check'].hide()"
          aria-label="Close"
        >
          <span aria-hidden="true" class="btn-close">&times;</span>
        </button>
      </template>
      <b-container fluid>採点結果に移動しますか？</b-container>
      <template v-slot:modal-footer>
        <button
          type="button"
          class="btn btn-secondary btn-modal"
          @click.prevent="$refs['modal-check'].hide()"
          @touchend.prevent="$refs['modal-check'].hide()"
        >
          いいえ
        </button>
        <button
          type="button"
          @click.prevent="end"
          @touchend.prevent="end"
          class="btn btn-modal-yes btn-modal"
        >
          はい
        </button>
      </template>
    </b-modal>
    <!-- モーダル ここまで-->

    <Comment
      v-if="sent && qComment"
      :qComment="qComment"
      :setting="setting"
      :config="config"
      :key="`comment${now}`"
      @hidden="isCommentShow = false"
      @show="isCommentShow = true"
    />

    <Timer
      ref="timer"
      :setTime="this.config.limitTime"
      @timer="
        (e) => {
          limitTime = e;
        }
      "
      @timeover="send"
      @next="next"
      :key="`timer${now}`"
    />
    <audio src="@/assets/audio/good.mp3" ref="goodmp3" />
    <audio src="@/assets/audio/bad.mp3" ref="badmp3" />
  </div>
</template>

<script>
/* eslint-disable no-console */
import QuestionHeader from "@/components/parts/QuestionHeader.vue";

import Comment from "@/components/questionPages/Question/parts/comment.vue";

import Presentations from "./parts/Presentations.vue";
import Forms from "./parts/Forms.vue";
import Timer from "./parts/Timer.vue";

import setConfig from "@/components/setConfig";

import Randomizer from "@/tools/randomizer";

export default {
  name: "QuestionIndex",
  components: {
    QuestionHeader,
    Comment,
    Presentations,
    Forms,
    Timer
  },
  data() {
    return {
      pause: false,

      limit: -1,
      limitTime: -1,

      transitionName: "prev",
      response: {},

      continueTimer: {},
      isCommentShow: false,

      setSend: false,
      spacerNeeded: true,

      page: -1,
    };
  },
  computed: {
    modal() {
      return this.$store.state.modal;
    },
    now() {
      return this.$store.state.questionId;
    },
    drills() {
      return this.$store.state.drills;
    },
    drill() {
      return this.$store.getters.drill;
    },
    setting() {
      return this.$store.state.setting;
    },
    config() {
      return this.$store.state.config;
    },
    questions() {
      return this.drill.questions;
    },
    question() {
      return this.$store.getters.question;
    },
    qComment() {
      return this.question.comment;
    },
    sent() {
      return this.$store.getters.sent || this.$store.state.mode === "end";
    },
    list() {
      return this.$store.getters.list;
    },
    optionsOrder() {
      return this.optionOrderList[this.now];
    },
    prevDisabled() {
      return this.now <= 0;
    },
    history() {
      return this.$store.getters.history;
    }
  },
  mounted() {
    this.setQuestion();
  },
  beforeDestroy() {
    clearTimeout(this.continueTimer);
  },
  methods: {
    send() {
      console.log("send");
      this.pauseTimer();
      this.$store.commit("setSent");
      this.setSend = true;
    },
    afterSend() {
      if (this.question.question.type !== "self" && this.config.audio) {
        if (this.$store.state.correct[this.now]) {
          this.$refs.goodmp3.play();
        } else {
          this.$refs.badmp3.play();
        }
      }
      if (this.config.continue) {
        this.continueTimer = setTimeout(() => {
          console.log(this.sent);
          console.log("continue Timer");
          this.next();
          console.log("send", "next");
        }, 3000);
      }

      this.setSend = false;
    },
    end() {
      this.$emit("end");
    },
    next(force) {
      if (!this.pause) {
        if (this.list.length > this.now + 1) {
          // this.now += 1;
          this.$store.commit("changeQuestion", this.now + 1);
        } else {
          if (this.config.continue && force === true) {
            this.end();
            return;
          }
          this.$refs["modal-check"].show();
        }
      }
    },
    prev() {
      if (0 <= this.now - 1 && !this.modal) {
        // this.now -= 1;
        this.$store.commit("changeQuestion", this.now - 1);
      }
    },
    setConfig,
    goIndex() {
      this.$emit("goIndex");
    },
    resumeTimer() {
      this.$refs.timer.resume();
    },
    startTimer() {
      this.$refs.timer.start();
    },
    pauseTimer() {
      console.log("pauze");
      this.$refs.timer.pause();
      clearTimeout(this.continueTimer);
    },

    randomizer: Randomizer,
    /*
    makeOptions() {
      if (!this.optionOrderList[this.now] && this.question.question.option) {
        const order = [];
        this.question.question.option.forEach((e, idx) => {
          order.push(idx);
        });
        if (this.question.question.random) {
          this.$set(this.optionOrderList, this.now, this.randomizer(order));
        }
        this.optionOrderList[this.now] = order;
        return order;
      }
    },
    */
    setQuestion() {
      this.setSend = false;
      if (!this.modal && this.now >= 0) {
        clearTimeout(this.continueTimer);
        window.scrollTo(0, 0);
        this.limit = this.config.limit;
        this.limitTime = this.config.limitTime;
        // this.makeOptions();
      }

      // this.loaded = false;

      this.comment = false;

      this.$nextTick(() => {
        setTimeout(() => {
          console.log("isNeeded?", this.$refs.qwrap.clientHeight);

          if (this.$refs.qwrap.clientHeight > window.innerHeight - 200) {
            this.spacerNeeded = true;
          } else {
            this.spacerNeeded = false;
          }
        }, 200);

        if (!this.modal) {
          window.scrollTo(0, 0);

          this.startTimer();
          if (this.sent) {
            console.log("sent!! PAUSED");
            this.pauseTimer();
          }
        }
        // this.loaded = true;
      });
    }
  },

  watch: {
    now() {
      this.setQuestion();
    },
    isCommentShow(nv) {
      console.log(this.isCommentShow);
      console.log(nv);
      clearTimeout(this.continueTimer);
    },
    sent(nv, pv) {
      console.log('sent', nv, pv, this.now);
      
      if (nv === true) {
        if (this.setSend) {
          this.afterSend();
        }
      }
    }
  }
};
</script>

<style scoped>
.page-wrap {
  height: 100%;
}

.page-wrap.is-modal {
  height: calc(100% - 2.5em);
}

.page-wrap .spacer {
  height: 4.5em;
  flex: 0 0 4.5em;

  margin-bottom: auto;
}

@media screen and (orientation: landscape) {
  .page {
    display: flex;
    flex-direction: column;
  }

  .page-wrap {
    height: 100%;
  }

  #question-wrap {
    display: flex;
    width: 100%;
    flex: 0 0 auto;

    flex-direction: row nowrap;
    justify-content: flex-start;
    align-items: flex-start;

    position: relative;

    margin-top: auto;
  }

  #question {
    display: flex;
    width: 100%;
    height: 100%;
    max-width: 90%;
  }

  .question-container {
    margin: auto;

    flex: 0 0 60%;
    padding-right: 2.5%;
    margin: auto;
  }

  .input-container {
    margin: auto;

    flex: 0 0 40%;
    padding-left: 2.5%;
    margin: auto;
  }
}

@media screen and (orientation: portrait) {
  #question-wrap {
    margin-top: 1em;
    margin-bottom: 1em;
  }
}

.presentation-block {
  width: 100%;
  display: flex;
  justify-items: center;
  align-items: center;
}

.presentation-block .disabled {
  opacity: 0.3;
}
</style>